"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Background = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div', {
  name: 'ImagePlaceholder',
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  height,
  isLoadingPlaceholder,
  isSquare,
  width,
  absolute
}) => ({
  alignItems: 'center',
  aspectRatio: isSquare ? '1 / 1' : undefined,
  background: isLoadingPlaceholder ? 'unset' : theme.palette.grey[100],
  boxSizing: 'content-box',
  color: theme.palette.grey[200],
  display: 'flex',
  height: height ?? '100%',
  justifyContent: 'center',
  left: '0',
  position: (Boolean(isSquare) || Boolean(width) || Boolean(height)) && !absolute ? 'relative' : 'absolute',
  top: '0',
  width: width ?? '100%',
  svg: {
    height: '100%',
    maxWidth: '130px',
    width: '40%',
    zIndex: 1
  }
}));
const Background = exports.Background = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  background: theme.palette.grey[100],
  position: 'absolute'
}));
